

import { Component, Mixins, Watch, Emit, Prop, Inject } from "vue-property-decorator";
import NumberFormat from "@/modules/NumberCore/NumberFormat";
import IBPaymentCardProps from "@/components/IBPayment/mixins/IBPaymentCardProps";
import IBPaymentCardColor from "@/components/IBPayment/mixins/IBPaymentCardColor";
import IBPaymentCardActionCaller from "@/components/IBPayment/mixins/IBPaymentCardActionCaller";
import IBCircleCheckbox from "@/components/IBCheckbox/IBCircleCheckbox.vue";
import IBPaymentCardContent from "@/components/IBPayment/IBPaymentCardContent.vue";
import { IPaymentCard, IPaymentCardFormattedAmount, TText } from "@/components/IBPayment/interface";
import GlobalMixin from "@/mixins/global";
import IBPaymentStateMixin from "@/mixins/payment-status/IBPaymentStateMixin";

@Component({
	components: {
		IBCircleCheckbox,
		IBPaymentCardContent
	}
})
export default class IBPaymentCard extends Mixins(
	GlobalMixin,
	IBPaymentCardProps,
	IBPaymentCardColor,
	IBPaymentCardActionCaller,
	IBPaymentStateMixin
) implements IPaymentCard {

	downloadFile: boolean = false

	active: boolean = this.expanded || false;

	@Inject({ default: () => {} })
	readonly isClicked!: (id: number) => void

	$refs!: {
		paymentCardHeader: HTMLElement
	}

	actionSavePayroll(e: number) {
		this.downloadFile = true
		this.$emit("userId", e)

		setTimeout(() => {
			this.downloadFile = false
		},100)
	}

	toggleContentVisibility(e: any): void {
		if (!this.downloadFile && this.isHistoryTypePyroll)
			this.$emit('getPayrollUserState', this.payrollUser);

    if (this.isRegisterOperation)
      this.$emit('openRegisterInfo', this.registerId);

		if (e.target.classList.contains('payment-card-icon')
			|| e.target.classList.contains('checkbox-inner')
			|| !this.isHistoryTypePyroll ? this.isExpandable === false : this.isExpandable === true) {
			if (this.isExpandable === false) this.callAction(this.action, [ this.active ]);

			return;
		}

		this.active = !this.active;
	}

	updateContentHeight() {
		const contentEl: HTMLElement | null | undefined = this.$refs.paymentCardHeader &&
			this.$refs.paymentCardHeader.nextElementSibling as HTMLElement;

		if (contentEl) {
			contentEl.style.maxHeight = this.active ? contentEl.scrollHeight + "px" : '';

			this.active && setTimeout(() =>
				contentEl.style.maxHeight = 'initial', 150);
		}
	}

	activeChangedHandler() {
		this.syncedExpanded = this.active;

		this.emitToggle();

		this.updateContentHeight();

		this.callAction(this.action, [ this.active ]);
	}

	get subTitleLocale(): TText {
		let test = ''
		if (!this.active && this.subTitle) {
			const textUpdate: string = this.subTitle as string
			test = textUpdate.slice(0, 50) + '...'
		}
		return test
	}

	get checkboxVisibility(): boolean {
		return !!(this.checkbox && (
			this.checkbox.hideIsResolution ? (
				!(<any>this)[this.checkbox.hideIsResolution] ||
					this.checkbox.visibility === true
			) : this.checkbox.visibility !== false
		));
	}

	get formattedAmount(): IPaymentCardFormattedAmount {
		const amount: number = +(this.amount || 0);
		const formattedAmount: string = `${NumberFormat.format(amount)} ${this.currency || 'UZS'}`;
		const [ main, sub ] = formattedAmount.split('.');

		return {
			main: this.showPositiveAmount && amount > 0
				? `+${main}`
				: main,
			sub: `.${sub}`
		};
	}

	@Watch('checkbox.checked')
	checkboxChanged(v: boolean) {
		this.callAction(this.checkbox.action, [ v ]);
	}

	@Watch('active')
	activeChanged() {
		this.activeChangedHandler();
	}

	@Emit('toggle')
	emitToggle() {}

}

